// extracted by mini-css-extract-plugin
export default {"showLessText":"TextMoreLess__showLessText___NLFDI","showMoreText":"TextMoreLess__showMoreText___kDAdl"};